export function metersToFeet (meters) {
  return meters && meters * 3.28084;
}
